import {
  PackageEndpointsV2,
  type PackagesAutocompleteResponse,
  type PackagesAutocompleteRequest,
  type PackagesAutocompleteResult,
} from "@b2bportal/core-packages";
import { LocationQueryEnum } from "@b2bportal/core-types";
import { axiosInstance } from "@hopper-b2b/api";

export const fetchLocations = async (
  search: string
): Promise<PackagesAutocompleteResult[]> => {
  try {
    const request: PackagesAutocompleteRequest = {
      query: {
        LocationQuery: LocationQueryEnum.Label,
        l: search,
      },
    };

    const { data: autocompleteResponse } =
      await axiosInstance.post<PackagesAutocompleteResponse>(
        PackageEndpointsV2.Autocomplete,
        request
      );

    return autocompleteResponse.categories[0].results;
  } catch (e) {
    return [];
  }
};
